import { render, staticRenderFns } from "./MedicineAdminPage.vue?vue&type=template&id=0fe763a6&scoped=true"
import script from "./MedicineAdminPage.vue?vue&type=script&lang=js"
export * from "./MedicineAdminPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe763a6",
  null
  
)

export default component.exports